<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>Projekti</h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <Loading :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="false"></Loading>

                <!--                {{projects}}-->
                <!--                <br/>-->
                <!--                {{users}}-->

                <vue-good-table
                        styleClass="vgt-table table table-hover table-striped"
                        :columns="columns"
                        :rows="projects"
                        :search-options="{
                                                        enabled: true,
                                                        skipDiacritics: true,
                                                        placeholder: 'vnesi iskalni pojem',
                                                    }"
                        :sort-options="{
                                                        enabled: true,
                                                      }">

                    <div slot="emptystate">
                        <div class="text-center text-muted font-weight-light"><i class="fa fa-exclamation-triangle"></i> <em>Ni podatkov.</em></div>
                    </div>

                    <template slot="table-row" slot-scope="props">

                        <span v-if="props.column.field == 'name'">
                            {{props.row.name}}
                        </span>

                        <!--                        <span v-if="props.column.field == 'projectManager'">-->
                        <!--                            {{getReadableUser(props.row.projectManager)}}-->
                        <!--                        </span>-->

                        <span v-else-if="props.column.field == 'id'">

                            <router-link :to="{ name: 'EditProject', params: {id: props.row.id }}"
                                         class="btn btn-primary btn-sm text-white">
                                <i class="fa fa-edit"></i> Uredi</router-link>

                            <a class="btn btn-danger btn-sm text-white ml-1"
                               @click="deleteUserConfirmation(props.row)"><i
                                    class="fa fa-trash"></i> Odstrani</a>
                        </span>
                    </template>
                </vue-good-table>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12 mt-3 mb-5">

                <router-link :to="{ name: 'EditProject' }" class="btn btn-success">
                    <i class="fa fa-plus"></i> Dodaj projekt
                </router-link>

            </div>
        </div>

    </div>

</template>

<script>
  import firebase from 'firebase'
  import {db} from '../main'
  import {VueGoodTable} from 'vue-good-table'
  import 'vue-good-table/dist/vue-good-table.css'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'Projects',
    components: {
      VueGoodTable,
      Loading
    },
    data () {
      return {
        isLoading: false,
        users: this.$store.getters.getUsers,
        projects: this.$store.getters.getProjects,
        columns: [
          {
            label: 'Ime',
            field: 'name',
            type: 'text',
            sortable: true,
          },
          // {
          //   label: 'Vodja',
          //   field: 'projectManager',
          //   type: 'text',
          //   sortable: true,
          // },
          {
            label: 'Akcije',
            field: 'id',
            type: 'text',
            sortable: false,
            width: '200px'
          }
        ],
      }
    },
    mounted () {
      const _this = this

      if (_this.$store.getters.getProjects.length === 0) {
        _this.$store.dispatch('retrieveProjects').then(() => {
          _this.projects = _this.$store.getters.getProjects
        })
      }

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers
        })
      }

    },
    methods: {

      deleteUserConfirmation (data) {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati projekt ' + data.first_name + ' ' + data.last_name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteUser(data.id)

              case null:

                return

                break

              default:

            }
          })
      },
      deleteUser (id) {
        const _this = this
        _this.isLoading = true
        db.collection('projects').doc(id).delete()
          .then(function () {
            _this.isLoading = false
            _this.$router.push('/projekti')
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting project: ', error)
          })
      },
      getReadableUser (userId) {
        const _this = this

        console.log(userId)

        let userObj = _.filter(_this.users, {'id': userId})[0]
        return userObj.first_name + ' ' + userObj.last_name

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Projects.vue